import { Waves } from "lucide-react";

const ITEMS = [
  "Weekly Pool Service",
  "Professional Water Chemistry",
  "Saltwater Pool Care",
  "Equipment & Repairs",
  "New Pool Startups",
  "Pinellas County, Florida",
];

export const EditorialMarquee = ({ dark = false }) => {
  const row = (key, hidden) => (
    <div key={key} aria-hidden={hidden} className="flex shrink-0 items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center shrink-0">
          <span className={`font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl px-6 sm:px-8 ${
            dark ? "text-white/90" : i % 2 ? "text-pine/90" : "text-navy/90"
          }`}>
            {item}
          </span>
          <Waves className={`w-5 h-5 shrink-0 ${dark ? "text-sky2/70" : i % 2 ? "text-lagoon/70" : "text-aqua/70"}`} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-8 sm:py-10 select-none ${dark ? "bg-navy" : "bg-mist"}`}
    >
      <div className="marquee-track">
        {row("a", false)}
        {row("b", true)}
      </div>
    </div>
  );
};
